import { render, staticRenderFns } from "./brand-detail.vue?vue&type=template&id=08d5d121&"
import script from "./brand-detail.vue?vue&type=script&lang=js&"
export * from "./brand-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports